export default function NextDoorIcon({
  className = "",
  strokeWidth = 1,
}: {
  className?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        d="M2 4.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v2a1 1 0 001 1h.155A7.5 7.5 0 0122 11.5v8a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-8a2.5 2.5 0 00-5 0v8a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-8H6a4 4 0 01-4-4v-3zM3 5v2.5a3 3 0 003 3h1.518a.5.5 0 01.498.535A6.6 6.6 0 008 11.5V19h3v-7.5a3.5 3.5 0 117 0V19h3v-7.5A6.5 6.5 0 008.87 8.25a.5.5 0 01-.434.25H8a2 2 0 01-2-2V5H3z"
      ></path>
    </svg>
  );
}
